<template>
  <v-dialog v-model="showDialog" v-if="showDialog" persistent scrollable :max-width="maxWidth || 530" :width="setWidth">
    <v-card>
      <v-card-title class="py-3 font-weight-medium base-dialog__title resBlue darken-1 white--text">
        <span class="resBlue darken-1 white--text body-2"> {{ dialogTitle }} </span>
        <v-spacer></v-spacer>
        <v-icon @click="close" color="white">close</v-icon>
      </v-card-title>
      <v-card-text :style="calculateHeight" class="base-dialog px-4">
        <v-row class="pt-2">
          <v-col cols="8" class="res-col-10">
            <label>Budget Group Type</label>
            <group-type-selector v-model="selectedGroupType" @input="groupTypeChanged"></group-type-selector>
          </v-col>
        </v-row>
        <v-row class="pb-2">
          <v-col cols="12" class="res-col-10">
            <span class="font-weight-bold">GL Accounts:</span><br />
            Shown below are GL Accounts that are excluded from the budget template. To include these in the budget template, edit an existing group or create a new budget group and add accordingly.
          </v-col>
        </v-row>
        <v-list single-line class="pa-0 ma-0 list-group" :loading="currentLoading">
            <template v-for="item in viewableGLAccounts">
              <v-list-item :key="item.value">
                <v-list-item-content>
                  <v-list-item-title v-html="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <p v-if="!(viewableGLAccounts && viewableGLAccounts.length > 0)" class="no-items-message"> {{ noExcludedGLAccountsText }} </p>
        </v-list>
      </v-card-text>
      <v-card-actions class="px-4 pt-0 pb-4 d-flex justify-end">
        <v-spacer></v-spacer>
        <res-button height='30px'
                  :dark="true"
                  :depressed="true"
                  buttonText='CLOSE'
                  backgroundColor='var(--v-resBlue-darken1)'
                  buttonTextColor='white'
                  @click='close'></res-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import ResButton from '@/components/base/ResButton.vue';
  import GroupTypeSelector from '@/components/templates/budget-groups/GroupTypeSelector.vue';
  import IsNullOrWhitespaceMixin from '@/mixins/isNullOrWhitespace.js';
  import templateService from '@/services/template'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'ExcludedGroupDialog',
    components: {
      ResButton,
      GroupTypeSelector
    },
    data: function () {
      return {
        selectedGroupType: {
          value: "1",
          text: 'Income'
        },
        excludedGLAccountsByType: []
      }
    },
    props: {
      showDialog: {
        type: Boolean
      },
      templateId: {
        type: String
      },
      maxWidth: {
        type: Number
      },
      setWidth: {
        type: Number
      },
      setHeight: {
        type: Number
      }
    },
    mixins: [IsNullOrWhitespaceMixin],
    methods: {
      ...mapActions(['changeLoading']),
      close() {
        this.$emit('cancel', true)
      },
      async getGLAccountsByGroupType(groupTypeId) {
        var self = this;
        self.changeLoading(true);
        try {
          let result = await templateService.getExcludedGLAccounts(self.templateId, groupTypeId);
          if (result) {
            self.excludedGLAccountsByType = result;
          }
        }
        catch (ex) {
          console.log(ex);
        }
        self.changeLoading(false);
      },
      groupTypeChanged(newType) {
        this.selectedGroupType = newType;
        this.getGLAccountsByGroupType(newType.value);
      }
    },
    computed: {
      ...mapGetters(['currentLoading']),
      dialogTitle() {
        return 'Excluded Accounts';
      },
      noExcludedGLAccountsText() {
        return 'There are no excluded GL Accounts for the selected group type';
      },
      calculateHeight() {
        return "height:" + this.setHeight + "px";
      },
      viewableGLAccounts() {
        var glAccounts = this._.map(this.excludedGLAccountsByType, function (glAccount) {
          return { text: `${glAccount.glAccountNumber}- ${glAccount.glAccountName}`, value: glAccount.glAccountId }
        });
        return glAccounts;
      }
    },
    async mounted() {
      this.changeLoading(true);
      await this.getGLAccountsByGroupType(this.selectedGroupType.value);
      this.changeLoading(false);
    }
  };
</script>

<style lang="scss" scoped>
  .v-input.v-input--dense.v-text-field.v-text-field--outlined::v-deep {
    .v-input__slot
    {
      min-height: 30px !important;
      border-radius: 6px;
    }
  }
  .list-group {
    width: 100%;
    height: 296px;
    overflow: auto;
    border: solid 1px #979797;
    background-color: #ffffff;
  }
  .no-items-message {
    border: 0px;
    height: 30px !important;
    min-height: 30px !important;
    margin: 10px;
    cursor: initial;
    background-color: #ffffff;
    font-style: italic;
  }
</style>

